import { StyledTextSpan } from "../styled-components/StyledConsentSpan";

export const DvsDisclosure = () => {
  return (
    <StyledTextSpan>
      I confirm that I am authorised to provide the personal details presented and I consent to the
      information being checked with the document issuer or official record holder via third party
      systems for the purpose of confirming my identity.
    </StyledTextSpan>
  );
};
